module.exports = __webpack_public_path__ + "img/A07-20070158-005.0f385f06.jpg";